export default __webpack_public_path__ + "static/media/footer.fe890a3a.png";